import * as yup from 'yup'
import * as numeral from 'numeral'
import { NONZERO_CURRENCY_INVALID, TYPE_REQUIRED } from 'constants/errors'

const trackerLimitFormSchema = yup.object().shape({
  limit: yup.mixed()
    .required(TYPE_REQUIRED)
    .test('non-zero currency', NONZERO_CURRENCY_INVALID, (value: string) => numeral(value).value() > 0),
})

export default trackerLimitFormSchema
